import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'components/shared/button';
import Link from 'components/shared/link';

const Cta = ({ title, description, linkText, linkUrl, buttonText, buttonUrl, theme }) => (
  <section
    className={clsx('cta safe-paddings overflow-hidden py-40 xl:py-30 lg:py-28 md:py-20', {
      'bg-white': theme === 'light',
      'relative bg-new-gray-2 after:absolute after:left-1/2 after:bottom-0 after:-translate-x-1/2 after:w-[1216px] after:h-px after:bg-[#E0E0EB] xl:after:w-[960px] lg:after:w-[762px] md:after:w-auto md:after:inset-x-4 md:after:translate-x-0':
        theme === 'gray',
    })}
  >
    <div className="container flex flex-col items-center">
      <h2 className="text-new-black text-[56px] leading-denser font-medium tracking-tight-4 text-center xl:text-[44px] lg:text-[36px] md:text-[32px]">
        {title}
      </h2>
      <p className="mt-5 text-xl leading-snug font-light text-new-gray-1 text-center xl:mt-4 xl:text-[18px] lg:mt-3.5 lg:text-[16px] md:xl:mt-3">
        {description}
      </p>
      <div className="mt-8 flex items-center gap-x-8 xl:mt-6 lg:mt-5 lg:gap-x-6 md:mt-6">
        <Button
          className="!font-medium !normal-case whitespace-nowrap !text-base !tracking-tight-2 lg:h-11 lg:min-w-[142px] lg:!text-[14px]"
          theme="secondary-2"
          size="medium"
          to={buttonUrl}
        >
          {buttonText}
        </Button>
        <Link
          className="xl:text-[16px] lg:text-[14px]"
          to={linkUrl}
          size="md"
          theme="secondary-2"
          withArrow
        >
          {linkText}
        </Link>
      </div>
    </div>
  </section>
);

Cta.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  theme: PropTypes.string,
};

Cta.defaultProps = {
  theme: 'light',
};

export default Cta;
